/* eslint-disable max-len */
import { FC } from 'react';

import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const PlusSubscriptionChevronIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.857 6.23025L4.2024 1.57878C4.12725 1.52242 4.0343 1.49506 3.9406 1.50171C3.84691 1.50837 3.75876 1.54861 3.69234 1.61503C3.62592 1.68145 3.58568 1.7696 3.57903 1.86329C3.57237 1.95699 3.59973 2.04995 3.65609 2.12509L8.03674 6.50575L3.65609 10.8864C3.61136 10.92 3.57437 10.9627 3.5476 11.0118C3.52084 11.0609 3.50495 11.1152 3.50098 11.1709C3.49702 11.2267 3.50508 11.2827 3.52463 11.335C3.54418 11.3874 3.57476 11.435 3.61429 11.4745C3.65383 11.5141 3.70139 11.5446 3.75377 11.5642C3.80615 11.5837 3.86211 11.5918 3.91788 11.5878C3.97365 11.5839 4.02792 11.568 4.07701 11.5412C4.12609 11.5144 4.16885 11.4774 4.2024 11.4327L8.857 6.77813C8.92897 6.70511 8.96932 6.60671 8.96932 6.50419C8.96932 6.40167 8.92897 6.30326 8.857 6.23025Z"
      strokeWidth="0.780449"
    />
  </svg>
);
